import { useTranslation } from "next-i18next"

import Button from "../../Button"

import Style from "./HomeMainButtons.module.scss"

export default function HomeMainButtons({ text, action }) {
  const { t } = useTranslation(["common", "tests"])

  return (
    <div className={Style.Wrapper}>
      <div className="text-black mt-5 flex flex-col justify-center  md:flex-row">
        <Button
          style="primary"
          className="mb-3 md:mb-0 md:mr-3"
          onClick={action}
          styles={{
            border: "2px solid #000000",
          }}
        >
          {text}
        </Button>
      </div>
      <div className={Style.NoCardCreditRequired}>
        {t("COMMON_NO_PAYMENT_REQUIRED")}
      </div>
    </div>
  )
}
